/**
 * CSV Utility Functions
 * Handles CSV generation, formatting, and downloads
 */

/**
 * Format date to DD/MM/YYYY
 * @param {string} isoDateString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatDateForCsv = (isoDateString) => {
  if (!isoDateString) return '';
  try {
    const date = new Date(isoDateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return '';
  }
};

/**
 * Escape CSV field to handle commas, quotes, and newlines
 * @param {*} field - Field value to escape
 * @returns {string} Escaped field value
 */
export const escapeCSVField = (field) => {
  if (field == null) return '';
  const stringField = String(field);
  if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
    return `"${stringField.replace(/"/g, '""')}"`;
  }
  return stringField;
};

/**
 * Convert array of data to CSV string
 * @param {Array} data - Array of objects to convert
 * @param {Array<{key: string, header: string, formatter?: Function}>} columnConfig - Column configuration
 * @returns {string} CSV string
 */
export const convertToCSV = (data, columnConfig) => {
  const headers = columnConfig.map(col => col.header);
  const csvRows = [headers.join(',')];

  data.forEach(item => {
    const row = columnConfig.map(col => {
      const value = col.formatter ? col.formatter(item) : item[col.key];
      return escapeCSVField(value);
    });
    csvRows.push(row.join(','));
  });

  return csvRows.join('\n');
};

/**
 * Trigger browser download of CSV content
 * @param {string} csvContent - CSV content to download
 * @param {string} filename - Filename for the download
 */
export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
